module.exports = __webpack_public_path__ + "static/media/bill_to@2x.78402d4a.png";